module.exports = __webpack_public_path__ + "img/icon-05.6be4c01b.svg";